import './styles.css';
import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import posthog from 'posthog-js'
import { environment } from '@environments/environment';


if (environment.POSTHOG_KEY) {
  posthog.init(environment.POSTHOG_KEY, {
    api_host: environment.POSTHOG_HOST,
    person_profiles: 'identified_only',
    defaults: '2025-05-24'
  });
}

bootstrapApplication(App, appConfig).catch(err => console.error(err));
